import { styled } from '@nextiva/next-ui-components';

export const LoadingLayout = styled('div')({
  display: 'grid',
  height: '30vh',
  placeItems: 'center',
});
